import { text } from "@atlas-int/tokens";

const HighlightOverlay = ({
  linkLookup,
  selection,
  nodeLookup,
  metaDataLookup,
  setHighlightedItem,
}) => {
  const focusNode = nodeLookup.get(selection);
  if (!focusNode) {
    return null;
  }
  return (
    <>
      <circle
        cx={focusNode.x}
        cy={focusNode.y}
        r={focusNode.r}
        strokeWidth="2.5"
        stroke={text.primary}
        style={{
          cursor: "pointer",
          pointerEvents: "none",
        }}
        fill={focusNode.fill}
      />
      {linkLookup[selection]?.map((productId) => {
        const node = nodeLookup.get(productId);
        if (!node) return null;
        return (
          <circle
            key={`highlight-node-${productId}`}
            cx={node.x}
            cy={node.y}
            r={node.r}
            strokeWidth="1.5"
            stroke={text.primary}
            style={{
              cursor: "pointer",
              pointerEvents: "none",
            }}
            fill={node.fill}
          />
        );
      })}
      {linkLookup[selection]?.map((productId) => {
        const source = nodeLookup.get(selection);
        const target = nodeLookup.get(productId);
        if (!source || !target) return null;
        return (
          <line
            key={`highlight-line-${productId}`}
            x1={source.x}
            x2={target.x}
            y1={source.y}
            y2={target.y}
            strokeWidth="1"
            stroke={text.primary}
            style={{
              cursor: "pointer",
              pointerEvents: "none",
            }}
            strokeLinecap="round"
          />
        );
      })}
    </>
  );
};

export default HighlightOverlay;
